// extracted by mini-css-extract-plugin
export default {"pressKit-container":"PressKitLayout_pressKit-container__Jrh8I","sidebar-wrapper":"PressKitLayout_sidebar-wrapper__4ai3k","main-content":"PressKitLayout_main-content__E1KN7"};